import { account } from "./appwrite";

async function jwt() {
  return (await account.createJWT()).jwt;
}

export async function adminGet<T>(path: string): Promise<T> {
  const response = await fetch(`/api/admin/${path}`, {
    headers: { Authorization: `Bearer ${await jwt()}` },
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || "Admin request failed");
  return body as T;
}

export async function adminPost<T>(path: string, payload: unknown): Promise<T> {
  const response = await fetch(`/api/admin/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await jwt()}`,
    },
    body: JSON.stringify(payload),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || "Admin request failed");
  return body as T;
}
